import { PriceSource } from "react-migration/domains/comparables/hooks/useComparableDetailData";
import { ZooplaLogoLarge } from "react-migration/domains/comparables/img/ZooplaLogoLarge";
import { HomeTrackLogoLarge } from "react-migration/domains/comparables/img/HomeTrackLogoLarge";
import { ComparableDetailSection } from "./ComparableDetailSection";
import { Banner } from "react-migration/domains/sites/components/Banner/Banner";

const HometrackByZoopla = () => {
  return (
    <div className="flex flex-row flex-wrap items-baseline justify-start gap-1 whitespace-pre">
      <HomeTrackLogoLarge className="w-auto h-[10px]" />
      <span className="text-xs font-normal text-blue-grey-600a">by</span>
      <ZooplaLogoLarge className="h-[10px] w-auto" />
      <span className="text-xs font-normal text-blue-grey-600a">, </span>
    </div>
  );
};

export const ComparableDetailSourceCard = ({ source }: { source: PriceSource }) => {
  return (
    <ComparableDetailSection>
      <Banner
        variant="info"
        showIcon
        className="w-full"
        message={
          <span className="flex flex-row flex-wrap items-center justify-start gap-1 text-xs text-blue-grey-600a">
            <span className="flex flex-row items-center justify-start gap-1 text-xs whitespace-pre text-blue-grey-600a">
              This information is sourced from
            </span>
            {source === PriceSource.HOMETRACK && <HometrackByZoopla />}
            <span className="flex flex-row items-center justify-start gap-1 text-xs whitespace-pre text-blue-grey-600a">
              HMLR, UK HPI, and EPC ratings
            </span>
          </span>
        }
      />
    </ComparableDetailSection>
  );
};
